const mutations = {
    SetQuestionInfo(state, info) {
        state.questionInfo = info

        sessionStorage.setItem('questionInfo', info)
    }
}
export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js